<template lang='pug'>
.fpui-action-list
  .action-container.color(
    :style='getStyle',
    :class='className',
    @mouseenter='toggle(true)',
    @mouseleave='toggle(false)'
  )
    .actions(:class='{unique:childrenNb === 1}')
      slot
    i.handle.fpui.fpui-dots(v-if='childrenNb !== 1')
</template>

<script>

export default {
  props: {
    noHover: { type: Boolean, default: false },
    color: { type: String, default: 'blue' }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    className () {
      let className = [this.color]
      if (this.noHover) className.push('no-hover')
      if (this.open) className.push('open')
      return className.join(' ')
    },
    getStyle () {
      let style = {
        left: 0
      }
      if (this.open) {
        style.left = `${-this.childrenNb * this.$el.offsetWidth}px`
      }
      return style
    },
    childrenNb () { return this.$slots.default.length }
  },
  methods: {
    toggle (value) {
      if (this.childrenNb === 1) return
      this.open = value
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-action-list-color-mixin(@color, @lightColor) {
  color: @color;
  &:hover, &.open {
    background-color: @lightColor;
    i:not(.disable):not(.handle):hover, .actions > *:not(.disable):hover {
      color: #fff;
      background-color: @color;
    }
    i.disable {
      cursor: initial;
    }
  }
  &.no-hover {
    background-color:white;
    i:not(.handle):hover, .actions > *:hover {
      color: @color;
      background-color:white;
    }
  }
}

.fpui-action-list {
  width: 40px;
  height: 30px;
  position: relative;
  .action-container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    transition: all 200ms ease-in-out;
    white-space: nowrap;
    border-radius: 5px;
    &.blue {
      .fpui-action-list-color-mixin(@blue, @blueLight);
    }
    &.green {
      .fpui-action-list-color-mixin(@green, lighten(@green, 43%));
    }
    &.yellow {
      .fpui-action-list-color-mixin(@yellow, lighten(@yellow, 43%));
    }
    &.red {
      .fpui-action-list-color-mixin(@red, lighten(@red, 43%));
    }
    &.grey {
      .fpui-action-list-color-mixin(@grey, lighten(@grey, 43%));
    }
    i, .actions > * {
      width: 40px;
      height: 100%;
      line-height: 30px;
      font-size: 18px;
      display: inline-block;
      cursor: pointer;
      text-align: center;
      border-radius: 3px;
      vertical-align: top;
      &.disabled {
        color:grey;
        cursor: not-allowed;
        &:hover {
          color: grey !important;
          background-color: transparent !important;
        }
      }
    }
    i.handle {
      position: absolute;
      right: 0;
      font-size: 18px;
      cursor: default;
    }
    .actions {
      display: inline-block;
      position: absolute;
      right: 40px;
      &.unique {
        right: 0;
      }
    }
  }
}
</style>
